import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { setComponentLoadingEffect } from "../../../Redux/common/Loader/action";
import { getCaseId, getClientId } from "../../../Utils/helper";
import { fetchCasePageClientProviders } from "../../../api/clientProviders";
import {
  setClientProviders,
  setLoading,
} from "../../../Redux/client-providers/clientProviderSlice";
import {
  useGetCaseProviders,
  useGetCaseSpecialities,
} from "../../TreatmentPage/hooks/useApiResource";
import { api_without_cancellation } from "../../../api/api";
import MedicalTreatmentIcon from "../../../assets/images/medical-treatment-icon.svg";
import PlaceHolderifNothingAdded from "../../components-new-final/placeholder-nothing-added";
import AddNewProvider from "../../TreatmentPage/modals/AddNewProvider";

const MedicalProviderPlaceholder = ({ refetchSpecial }) => {
  const [newProviderShow, setNewProviderShow] = useState(false);
  const dispatch = useDispatch();
  const { data: caseProvidersList } = useGetCaseProviders();
  const { data: specialitiesList } = useGetCaseSpecialities();
  const handleNewProviderClose = useCallback((shouldRefresh = false) => {
    setNewProviderShow(false);

    if (shouldRefresh === "true") {
      dispatch(setComponentLoadingEffect("medicalProviders", true));
      fetchCasePageClientProviders(getClientId(), getCaseId())
        .then((data) => {
          dispatch(setClientProviders(data?.results));
          setLoading({
            key: "all",
            value: false,
          });
          dispatch(setComponentLoadingEffect("medicalProviders", false));
        })
        .catch((error) => {
          console.error("Error occurred while fetching client-providers", error);
          dispatch(setComponentLoadingEffect("medicalProviders", false));
          setLoading({
            key: "all",
            value: false,
          });
        });
      refetchSpecial();
    }
  }, []);
  const [firmName, setFirmName] = useState();

  useEffect(() => {
    async function fetchFirmName() {
      try {
        const response = await api_without_cancellation.get(
          `/api/cases/${getClientId()}/${getCaseId()}/summary/`
        );

        setFirmName(response?.data);
      } catch (error) {
        console.error("Error fetching firm name:", error);
      }
    }

    fetchFirmName();
  }, [getClientId(), getCaseId()]);
  return (
    <>
      {newProviderShow && (
        <AddNewProvider
          show={newProviderShow}
          handleClose={() => {
            handleNewProviderClose("true");
          }}
          firmName={firmName}
          caseProvider={caseProvidersList}
          specialitie={specialitiesList}
        />
      )}
      <tr>
        <td colSpan={18} style={{ position: "relative" }}>
          <PlaceHolderifNothingAdded
            text1="No Medical Providers Added to the Case"
            text2="Click to Add"
            pageIcon={MedicalTreatmentIcon}
            onClick={() => setNewProviderShow(true)}
            cn={"placeholder-wrapper-treatment "}
          />
        </td>
      </tr>
    </>
  );
};

export default MedicalProviderPlaceholder;
